import { TFunction } from 'i18next';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { publish, SubscriptionTopic } from '../../../../../../viewer/messaging/pubsub';
import { projectStateAdapter } from '../../../../../state/project-state/project-state-adapter';
import { Button } from '../../../../button/button';
import { InfoBox } from '../../../../info-box/info-box';
import { CollapsableSectionGroup } from '../../../../skyview/right-menu/components/collapsable-section-group';
import {
  RightPanelContent,
  RightPanelFooter,
} from '../../../../skyview/right-menu/components/styles';
import { Stack } from '../../../../stack/stack';
import { reportHelpers } from '../helpers';
import { NoVolumesPanel } from '../helpers/no-volumes-panel';
import { useVolumesWithAssets } from '../helpers/use-volume-with-assets';
import { findSelectedVolumes, hasSelectedAssets, VolumeWithAsset } from '../helpers/utils';
import { VolumeMultiSelectListSection } from '../helpers/volume-multi-select-list-section';

export const VolumeOverviewCsvReportMenu = () => {
  const { t } = useTranslation();
  const { volumesWithAssets, setVolumesWithAssets } = useVolumesWithAssets();

  if (volumesWithAssets.length === 0) {
    return <NoVolumesPanel />;
  }

  return (
    <>
      <RightPanelContent useTopPadding={false}>
        <CollapsableSectionGroup>
          <VolumeMultiSelectListSection
            loading={false}
            setVolumesWithAssets={setVolumesWithAssets}
            volumesWithAssets={volumesWithAssets}
          />
        </CollapsableSectionGroup>
      </RightPanelContent>

      <RightPanelFooter>
        <Stack direction="column" spacing={0.4}>
          <InfoBox color="yellow">
            {`${t('export.volumesSelected', { ns: 'skyviewReport' }) as string}: ${
              volumesWithAssets?.filter((x) => x.selected).length ?? 0
            } / ${volumesWithAssets?.length ?? 0}`}
          </InfoBox>

          <Button
            color={'primary'}
            disabled={!hasSelectedAssets(volumesWithAssets)}
            variant={'contained'}
            width="100%"
            onClick={() => {
              const selectedVolumes = findSelectedVolumes(volumesWithAssets);
              exportReport(selectedVolumes, t);
            }}
          >
            {t('exportButton', { ns: 'skyviewReport' })}
          </Button>
        </Stack>
      </RightPanelFooter>
    </>
  );
};

function exportReport(selectedVolumes: VolumeWithAsset[], t: TFunction) {
  try {
    reportHelpers.exportVolumeCsvReport(
      projectStateAdapter.getSnapshot().project!.name,
      selectedVolumes,
    );
  } catch (error) {
    publish(SubscriptionTopic.ToastrMessage, {
      message: t('exportError', { ns: 'skyviewReport' }) as string,
      type: 'error',
    });
  }
}
